<div
  class="mb-2 text-center"
  *ngIf="
    showHeader &&
    !isWorkflowData &&
    isVideo != 'Welcome Video Node' &&
    !isBtnShow &&
    !showOnboardingButton
  "
>
  <h2
    class="text-base font-semibold mt-4 card-title"
    [ngClass]="{ 'text-center': isVideo == 'Welcome Video Node' }"
  >
    {{ formData?.formCollection?.formName }}
  </h2>
  <p class="text-2sm font-medium text-gray-600 px-7 mt-1">
    {{ formData?.formCollection?.formDescription }}
  </p>
</div>
<div
  class="flex justify-end"
  *ngIf="formData?.formCollection?.fieldCollectionName == 'integrationCategory'"
>
  <button
    class="btn btn-sm btn-primary"
    [disabled]="childLoading"
    (click)="reloadData()"
  >
    <ng-container *ngIf="!childLoading">
      <i class="ki-filled ki-arrows-circle text-xl"></i> Reload
    </ng-container>

    <ng-container *ngIf="childLoading">
      <div class="loader"></div>
      Loading...
    </ng-container>
  </button>
</div>
<form *ngIf="saveForm" [formGroup]="saveForm" autocomplete="off">
  <span
    class="text-2xl font-semibold ms-4 p-4 text-center align-items-center"
    *ngIf="
      showHeader &&
      isWorkflowData &&
      isVideo != 'readyToDashboard' &&
      !isBtnShow &&
      isVideo == 'Welcome Video Node'
    "
    [innerHTML]="formData?.formCollection?.formName"
  >
    <!-- {{ formData?.formCollection?.formName }} -->
  </span>
  <div
    [ngClass]="{
      'card rounded-xl bg-white dark:bg-coal-700 mb-4':
        (isWorkflowData && !isBtnShow) || isButtonShow,
      'flex flex-col items-center': isVideo == 'Welcome Video Node',
    }"
  >
    <div class="flex flex-row">
      <span
        class="text-base font-semibold ms-4 p-4"
        *ngIf="
          showHeader &&
          isWorkflowData &&
          isVideo != 'readyToDashboard' &&
          !isBtnShow &&
          isVideo != 'Welcome Video Node'
        "
      >
        {{ formData?.formCollection?.formName }}</span
      >
      <div
        *ngIf="
          formData?.formCollection?.taskMapping &&
          (applicableTaskSummary.toDo > 0 ||
            applicableTaskSummary.deployed > 0 ||
            applicableTaskSummary.notApplicable > 0)
        "
        class="ms-auto flex flex-row flex-wrap gap-3 px-3 py-2"
      >
        <!-- TO DO -->
        <div
          *ngIf="applicableTaskSummary.toDo > 0"
          class="flex items-center gap-2 px-4 py-2 rounded-xl border"
          [ngStyle]="getBadgeStyle('to do')"
        >
          <!-- ICON -->
          <i class="fas fa-list-check text-sm"></i>

          <!-- LABEL -->
          <span class="text-xs font-semibold">Marked as To Do </span>

          <!-- COUNT -->
          <span
            class="min-w-[28px] h-[28px] flex items-center justify-center rounded-lg text-2sm font-medium px-2 text-white"
            [ngStyle]="{
              backgroundColor: getBadgeStyle('to do')?.color,
            }"
          >
            {{ applicableTaskSummary.toDo }}
          </span>
        </div>

        <!-- DEPLOYED -->
        <div
          *ngIf="applicableTaskSummary.deployed > 0"
          class="flex items-center gap-2 px-4 py-2 rounded-xl border"
          [ngStyle]="getBadgeStyle('deployed')"
        >
          <!-- ICON -->
          <i class="fas fa-circle-check text-sm"></i>

          <!-- LABEL -->
          <span class="text-xs font-semibold">Marked as Deployed </span>

          <!-- COUNT -->
          <span
            class="min-w-[28px] h-[28px] flex items-center justify-center rounded-lg text-2sm font-bold px-2 text-white"
            [ngStyle]="{
              backgroundColor: getBadgeStyle('deployed')?.color,
            }"
          >
            {{ applicableTaskSummary.deployed }}
          </span>
        </div>

        <!-- NOT APPLICABLE -->
        <div
          *ngIf="applicableTaskSummary.notApplicable > 0"
          class="flex items-center gap-2 px-4 py-2 rounded-xl border"
          [ngStyle]="getBadgeStyle('not applicable')"
        >
          <!-- ICON -->
          <i class="fas fa-ban text-sm"></i>

          <!-- LABEL -->
          <span class="text-xs font-semibold">Marked as Not Applicable </span>

          <!-- COUNT -->
          <span
            class="min-w-[28px] h-[28px] flex items-center justify-center rounded-lg text-2sm font-bold px-2 text-white"
            [ngStyle]="{
              backgroundColor: getBadgeStyle('not applicable')?.color,
            }"
          >
            {{ applicableTaskSummary.notApplicable }}
          </span>
        </div>
      </div>
    </div>

    <div
      class="separator"
      *ngIf="
        (formData?.formCollection?.formName &&
          isWorkflowData &&
          isVideo != 'readyToDashboard' &&
          !isBtnShow &&
          isVideo != 'Welcome Video Node') ||
        (isButtonShow && !showOnboardingButton)
      "
    ></div>
    <div
      [ngClass]="{
        'px-8 mb-8 h-auto':
          workflowData?.layout.leftColumnProperties?.showStepper ||
          isButtonShow,
      }"
    >
      <div class="custom-scroll-area">
        <ng-container *ngFor="let field of formFields">
          <ng-container *ngIf="visibleFields[field.fieldName] !== false">
            <app-checkbox-type-one
              *ngIf="field.componentId == 'checkboxTypeOne'"
              [formGroup]="saveForm"
              [fields]="field"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            ></app-checkbox-type-one>
            <app-checkbox-type-two
              *ngIf="field.componentId == 'checkboxTypeTwo'"
              [formGroup]="saveForm"
              [fields]="field"
              [disableFields]="disableFields"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            ></app-checkbox-type-two>
            <app-checkbox-type-three
              *ngIf="field.componentId == 'checkboxTypeThree'"
              [formGroup]="saveForm"
              [fields]="field"
              [nodeId]="nodeId"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            >
            </app-checkbox-type-three>
            <app-checkbox-type-four
              *ngIf="field.componentId == 'checkboxTypeFour'"
              [formGroup]="saveForm"
              [fields]="field"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            >
            </app-checkbox-type-four>
            <app-checkbox-type-five
              *ngIf="field.componentId == 'checkboxTypeFive'"
              [formGroup]="saveForm"
              [fields]="field"
              [visibleFields]="visibleFields"
              (visibilityChanged)="onVisibilityChange($event)"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            >
            </app-checkbox-type-five>
            <app-checkbox-type-six
              *ngIf="field.componentId == 'checkboxTypeSix'"
              [formGroup]="saveForm"
              [fields]="field"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            >
            </app-checkbox-type-six>
            <app-placeholder-with-text
              *ngIf="
                field.componentId == 'noDataTypeOne' ||
                field.componentId == 'noDataTypeTwo'
              "
              [formGroup]="saveForm"
              [fields]="field"
            ></app-placeholder-with-text>
            <app-data-view-with-loader
              *ngIf="field.componentId == 'dataViewWithLoader'"
              [formGroup]="saveForm"
              [fields]="field"
              [workflowData]="workflowData"
            ></app-data-view-with-loader>
            <app-input-text-field
              *ngIf="field.componentId == 'inputTextField'"
              [formGroup]="saveForm"
              [fields]="field"
              [disableFields]="disableFields"
              [autoFocused]="field.fieldName === firstFocusFieldName"
            >
            </app-input-text-field>
            <app-input-field-with-label-above
              *ngIf="field.componentId == 'inputTextFieldAbove'"
              [formGroup]="saveForm"
              [fields]="field"
              [disableFields]="disableFields"
              [autoFocused]="field.fieldName === firstFocusFieldName"
            ></app-input-field-with-label-above>
            <app-checkbox-with-text
              *ngIf="field.componentId == 'checkboxField'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-checkbox-with-text>
            <app-otp-field
              *ngIf="field.componentId == 'otpInputField'"
              [formGroup]="saveForm"
              [fields]="field"
              [workflowData]="workflowData"
              (otpCompleted)="onSave($event)"
              [autoFocused]="true"
            ></app-otp-field>
            <app-otp-header-field
              *ngIf="field.componentId == 'otpHeaderField'"
              [fields]="field"
              [workflowData]="workflowData"
            ></app-otp-header-field>
            <app-label-type-one
              *ngIf="field.componentId == 'labelTypeOne'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-label-type-one>
            <app-question-with-options
              *ngIf="field.componentId == 'questionWithOptions'"
              [formGroup]="saveForm"
              [fields]="field"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            ></app-question-with-options>
            <app-modal-button
              *ngIf="field.componentId == 'addDomainButton'"
              [fields]="field"
            ></app-modal-button>
            <app-domain-rows
              *ngIf="field.componentId == 'domainRows'"
              [formGroup]="saveForm"
              [fields]="field"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            ></app-domain-rows>
            <div class="ms-3 flex justify-center">
              <app-video
                #video
                [width]="'600px'"
                [height]="'330px'"
                *ngIf="field.componentId == 'videoPlayer'"
                [videoId]="'TQdhyAZxDCo'"
                [ngStyle]="{
                  height: field.properties.videoHeight,
                  width: field.properties.videoWidth,
                }"
                [isVideo]="isVideo"
                [fields]="field"
                [imagePath]="
                  './assets/media/illustrations-image/illustration-4.png'
                "
              ></app-video>
            </div>
            <app-dropdown-select
              *ngIf="field.componentId == 'dropdownSelect'"
              [formGroup]="saveForm"
              [fields]="field"
              [disableFields]="disableFields"
            ></app-dropdown-select>
            <app-dropdown-with-search
              *ngIf="field.componentId == 'dropdownWithSearch'"
              [formGroup]="saveForm"
              [fields]="field"
              [labelAbove]="labelAbove"
              [autoFocused]="field.fieldName === firstFocusFieldName"
              [twoGridColumn]="twoGridColumn"
              [disableFields]="disableFields"
            ></app-dropdown-with-search>
            <app-view-card
              *ngIf="field.componentId == 'viewCard'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-view-card>
            <!-- [sseConfig]="formData?.sseConfig"
              [formId]="formData?.formFields[0]?.formId"
              [workflowData]="workflowData" -->
            <app-table
              *ngIf="field.componentId == 'table'"
              [formGroup]="saveForm"
              [fields]="field"
              [isWriteAccess]="!disableFields"
            ></app-table>
            <app-ready-dashboard
              *ngIf="field.componentId == 'readyDashboard'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-ready-dashboard>
            <app-resend-otp
              *ngIf="field.componentId == 'resendOTP'"
              [formGroup]="saveForm"
              [fields]="field"
              [workflowData]="workflowData"
            ></app-resend-otp>
            <app-phone-number
              *ngIf="field.componentId == 'phoneNumber'"
              [formGroup]="saveForm"
              [fields]="field"
              [labelAbove]="true"
            ></app-phone-number>
            <app-integration-cards-pro
              *ngIf="field.componentId == 'integrationCards'"
              [formGroup]="saveForm"
              [fields]="field"
              [limit]="500"
              (loadingChange)="childLoading = $event"
            ></app-integration-cards-pro>
            <app-image-with-text
              *ngIf="field.componentId == 'imageWithText'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-image-with-text>
            <app-integration
              *ngIf=""
              [formGroup]="saveForm"
              [fields]="field"
            ></app-integration>
            <app-summary
              *ngIf="field.componentId == 'summary'"
              [formGroup]="saveForm"
              [fields]="field"
              [formData]="formData"
              (buttonClick)="onSave($event)"
            ></app-summary>
            <app-summary-view
              *ngIf="field.componentId == 'summaryView'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-summary-view>
            <app-summary-cards
              *ngIf="field.componentId == 'summaryCards'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-summary-cards>
            <app-config-with-button
              *ngIf="field.componentId == 'configurationWithButton'"
              [formGroup]="saveForm"
              [fields]="field"
              [formData]="formData"
              (buttonClick)="onSave($event)"
            ></app-config-with-button>
            <app-configuration-cards
              *ngIf="field.componentId == 'configurationCards'"
              [formGroup]="saveForm"
              [fields]="field"
              [formData]="formData"
              (buttonClick)="onSave($event)"
            ></app-configuration-cards>
            <app-checkbox-type-seven
              *ngIf="field.componentId == 'checkboxTypeSeven'"
              [formGroup]="saveForm"
              [fields]="field"
              [visibleFields]="visibleFields"
              (visibilityChanged)="onVisibilityChange($event)"
            >
            </app-checkbox-type-seven>
            <app-checkbox-type-eight
              *ngIf="field.componentId == 'checkboxTypeEight'"
              [formGroup]="saveForm"
              [fields]="field"
              (handleTaskMappingDependency)="
                handleTaskMappingDependency($event)
              "
            ></app-checkbox-type-eight>
            <app-login-cards
              *ngIf="field.componentId == 'loginCards'"
              [formGroup]="saveForm"
              [fields]="field"
            ></app-login-cards>
          </ng-container>
        </ng-container>
      </div>
      <div
        class="separator mt-4"
        *ngIf="
          isWorkflowData &&
          isVideo != 'readyToDashboard' &&
          isVideo != 'Welcome Video Node'
        "
      ></div>

      <div
        class="p-0 m-0"
        *ngIf="
          !workflowData?.layout.leftColumnProperties?.showStepper &&
          !isBtnShow &&
          !isButtonShow
        "
      >
        <app-buttons
          *ngIf="nodeId != '68ce7e74033c24bd2028c347'"
          (buttonClick)="onSave($event)"
          [btnFields]="footerFields"
          [isLoading]="isLoading"
        >
        </app-buttons>
        <app-integration
          *ngIf="nodeId == '68ce7e74033c24bd2028c347'"
        ></app-integration>
      </div>
    </div>
  </div>
  <!-- Buttons -->
  <div class="flex justify-end" *ngIf="showOnboardingButton">
    <button
      type="button"
      [disabled]="nodeId !== emailSettingsFormId || isLoading"
      class="rounded-md transition-all flex items-center gap-2 btn btn-primary"
      (click)="onSave({ componentId: 'save' })"
    >
      Save
      <div class="loader" *ngIf="isLoading"></div>
    </button>
  </div>
  <div
    class="p-0 m-0"
    *ngIf="workflowData?.layout.leftColumnProperties?.showStepper"
  >
    <app-buttons
      *ngIf="nodeId != '68ce7e74033c24bd2028c347'"
      (buttonClick)="onSave($event)"
      [btnFields]="footerFields"
      [isButtonShow]="isButtonShow"
    >
    </app-buttons>
  </div>
</form>
